import React, { useEffect, useRef, useState } from 'react';
import FeedBackMessage from './FeedBackMessage';
import { Link } from 'react-router-dom';
import { axiosInstance } from '../../utils/axiosInterceptor';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Modal } from 'antd';
import ProfileIndex from '../../pages/Profile/ProfileIndex';

function FeedBacks({ vacancyId }) {
  const [openUser, setOpenUser] = useState();
  const [items, setItems] = useState([]);
  const [data, setData] = useState();
  const page = useRef(1);
  const onFetchApplications = () => {
    axiosInstance
      .get(`${process.env.REACT_APP_SERVER_API}/vacancies/applications`, {
        params: { page: page.current, vacancy_id: vacancyId },
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      })
      .then((res) => {
        setItems((prev) => [...prev, ...res.data.results]);
        setData(res.data);
      });
  };

  useEffect(() => {
    onFetchApplications();

    return () => {
      setData();
      setItems([]);
      page.current = 1;
    };
  }, []);

  return (
    <>
      <div className="flex justify-start w-full flex-col">
        <div className="flex items-center relative w-full">
          <Link to={`/applications/${vacancyId}`}>
            <h2 className="text-[20px] tracking-[1px] font-semibold">Отклики:</h2>
          </Link>
        </div>
        <div className="flex items-center flex-col border-1 rounded-md mt-2 border-gray-200 shadow-md">
          <div className="h-56 max-h-56 overflow-y-scroll flex flex-col items-start w-full mt-2 pb-10 scrollbar-thin scrollbar-thumb-[#888] scrollbar-track-[#f1f1f1]" id="other-list">
            <ul className="w-full justify-around  p-3 pr-5 list-item">
              {!items.length ? (
                <li className="flex justify-center font-bold opacity-50 h-[160px] items-center">Откликов нет</li>
              ) : (
                <InfiniteScroll
                  className=""
                  dataLength={items.length}
                  scrollableTarget="other-list"
                  next={() => {
                    console.log('next');
                    if (data?.next) {
                      page.current += 1;
                      onFetchApplications();
                      //   dispatch(getEmployerList({ ...activeEmployerFilter.params, name: textEmployerFilter, page: page.current, ...(sortEmployerList && { ordering: 'id' }) }));
                    }
                  }}
                  hasMore={true}>
                  {items.map((item) => (
                    <FeedBackMessage
                      key={item?.id}
                      {...item}
                      onClick={() => {
                        setOpenUser(item?.candidate?.id);
                      }}
                    />
                  ))}
                </InfiniteScroll>
              )}

              {/* <FeedBackMessage />
            <FeedBackMessage />
            <FeedBackMessage />
            <FeedBackMessage /> */}
            </ul>
          </div>
        </div>
      </div>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        open={openUser}
        width={'100%'}
        onCancel={() => {
          setOpenUser(null);
        }}
        footer={['']}>
        <ProfileIndex userId={openUser} />
      </Modal>
    </>
  );
}

export default FeedBacks;
